// API Configuration
export const API_CONFIG = {
  // Change this to match your server's URL and port
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  
  // Common endpoints
  endpoints: {
    login: '/auth/login',
    register: '/auth/register',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    generateOTP: '/auth/generate-otp',
    verifyOTP: '/auth/verify-otp',
    verifyEmail: '/auth/verify-email',
    resendVerification: '/auth/resend-verification',
    formPatterns: '/api/form-patterns',
    formSubmissions: '/api/form-submissions',
    patients: '/patients',
    reports: '/reports',
  },
  
  // Request timeout in milliseconds
  timeout: 10000,
  
  // Default headers
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};

export default API_CONFIG;
